module.exports = __webpack_public_path__ + "static/media/newline9.32287443.jpg";